export const rafThrottle = <TArgs extends unknown[]>(fn: (...args: TArgs) => void) => {
  let handle = 0;
  let scheduled = false;
  let latestArgs: TArgs | null = null;

  const flush = () => {
    scheduled = false;
    if (latestArgs) {
      const argsToUse = latestArgs;
      latestArgs = null;
      fn(...argsToUse);
    }
  };

  const throttled = (...args: TArgs) => {
    latestArgs = args;
    if (scheduled) return;

    scheduled = true;
    handle = requestAnimationFrame(flush);
  };

  throttled.cancel = () => {
    if (scheduled) {
      cancelAnimationFrame(handle);
      scheduled = false;
    }
    latestArgs = null;
  };

  return throttled;
};
